//extends functionality of parsley to suit our needs


bq.global.parsley = {
  defaults: {//set our default configs for parsley
    excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden]:not(.ignore-exclude), :disabled:not(.ignore-exclude), :hidden:not(.ignore-exclude):not(select.selectbox-data):not(input.selectbox-data):not(.select2), .ignore-validation-on-hide.hide :input, input.deactivate-validation, .delegation-form.hide input',
    // Do not validate
    // input[type=hidden] &
    // :disabled but added
    // .ignore-exclude for select2
    successClass: 'has-success',               // Class name on each valid input
    errorClass: 'has-error has-feedback',      // Class name on each invalid input
    showErrors: true,                          // Set to false if you don't want Parsley to display error messages
    namespace: 'data-validate-',

    fieldValidationPrefix: 'validate-', // [custom] prefix for each form element type, exmpl: "validate-select", "validate-input"

    classHandler: function (el) {
      return (el.$element.closest('.form-group').length) ? el.$element.closest('.form-group') : el.$element.parent();
    },
    errorsWrapper: '',//<span class="fa fa-times text-error form-control-feedback"></span>'
    errorTemplate: '',//<span class="sr-only"></span>'
    classMap: {
      'validate-select': {validation: 'required', value: true},
      'required-entry': {validation: 'required', value: true},
      'validate-one-required-by-name':  {validation: 'required', value: true},
      'validate-number': {validation: 'type', value: 'number'},
      'validate-zero-or-greater': {validation: 'min', value: '0'},
      'validate-greater-than-zero': {validation: 'greaterthanzero', value: true},
      'validate-digits': {validation: 'type', value: 'digits'},
      'validate-digits-range': {validation: 'range', value: '[$1,$2]', regex: /digits-range-([0-9]+)-([0-9]+)/},
      'validate-alphanum': {validation: 'type', value: 'alphanum'},
      'validate-date': {validation: 'date', value: true}, //see custom date validation in vendor/validation/custom.validations.js
      'validate-email': {validation: 'type', value: 'email'},
      'maximum-length-': {validation: 'maxlength', value: '$1', regex: /maximum-length-([0-9]+)/},
      'minimum-length-': {validation: 'minlength', value: '$1', regex: /minimum-length-([0-9]+)/},
      'validate-percents': {validation: 'max', value: '100'},
      'validate-alphanum-with-spaces': {validation: 'alphanumwithspaces', value: 'true'}, //TODO
      'validate-emails': {validation: 'emails', value: 'true'},
      'validate-phone-number': {validation: 'buyerquestphonenumber', value: true},
      'validate-fax': {validation: 'buyerquestphonenumber', value: true},
      'validate-integer': {validation: 'integer', value: true},
      'validate-login-id': {validation: 'loginid', value: true},
      'validate-net-amount': {validation: 'netamount', value: true},
      'validate-min-net-amount': {validation: 'minnetamount', value: true},
      'validate-float-number': {validation: 'floatnumber', value: true},
      'validate-qty-input': {validation: 'qtyinput', value: true},
      'validate-expiration-date': {validation: 'expirationdate', value: true}
    }
  },

  // call back for form validation, allows us to prepare form
  formValidate: function(parsley) {
    $('.form-control-feedback', parsley.$element).remove();
    bq.helper.throwEvent('bq.form.validate', parsley.$element);
    parsley._refreshFields();
  },

  // call back after form validation
  formValidated: function(parsley) {
      bq.helper.throwEvent('bq.form.validated', parsley.$element);
  },

  // call back for field error, allows us to do custom error handling
  fieldError: function(el) {
    if ('string' === typeof el.options.errorsContainer) {
      $(el.options.errorsContainer)
        .html(window.ParsleyValidator.getErrorMessage(el.validationResult[0].assert))
        .show();
      return;
    }
    if(el.options.classHandler(el).find('.form-control-feedback').length) { return; }

    var icon = $('<span class="fa fa-exclamation-triangle text-error form-control-feedback form-validation-error"></span>');
    var iconMargin = $('<span class="fa fa-exclamation-triangle text-error form-control-feedback form-validation-error" style="margin-right: 15px;z-index: 10001;"></span>');
    var label = el.options.classHandler(el).find('label').first();
    var iconMarginApplied = false;
    if( label.length >= 1 && !(label.hasClass("sr-only") || label.parent('div').hasClass("sr-only"))  && !label.hasClass('element-radio') && !label.hasClass('select2-offscreen')) {
      label.prepend(icon);
    } else {
        var e = el.options.classHandler(el);
        if(e.hasClass('attachment-block')) {
          e.find('.attachment-block-table tr:first-child .upload-file-name').append(" ").append(icon);
        } else if(el.options.classHandler(el).find('.select2').length > 0) {
          e.prepend(iconMargin);
          iconMarginApplied = true;
        } else {
          var dataset = e.context === undefined && e.length === 1 ? el.$element[0].dataset : e.context.dataset;
          var elem = !document.body.contains(e.context) ? $(document.body).find("[data-validate-id='" + dataset.validateId + "']")[0] : e.context,
              errorBlock,
              errorHostSelector = elem.dataset.validateParsleyErrorHostSelector;

          if (errorHostSelector) {
            errorBlock = $(document.body).find(errorHostSelector);
            errorBlock.children('.fa.fa-exclamation-triangle').remove();
            errorBlock.append(icon);
          } else if (elem.nodeName.toLowerCase() === 'input'
              || elem.nodeName.toLowerCase() === 'select'
              || elem.nodeName.toLowerCase() === 'textarea'
          ) {
            $(elem).parent().append(icon);
          } else {
            elem.append(icon);
          }
       }
    }

    function tooltipPlacement(tooltip, el) {
      if (bq.helper.mq.is('xs') && $(el).parent().hasClass('form-group')) {
        return 'auto right';
      }
      return 'bottom auto';
    }

    var message;
    if (el.options['errorMessage']) {
      message = el.options['errorMessage'];
    } else {
      message = window.ParsleyValidator.getErrorMessage(el.validationResult[0].assert);
    }

    if (iconMarginApplied) {
      iconMargin.tooltip({
        container: 'body',
        html: true,
        placement: tooltipPlacement,
        title: message
      });
    } else {
      icon.tooltip({
        container: 'body',
        html: true,
        placement: tooltipPlacement,
        title: message
      });
    }

    bq.global.bootstrapFixes();
  },

  // call back for field success, allows us to do custom error handling
  fieldSuccess: function(el) {
    if ('string' === typeof el.options.errorsContainer) {
      $(el.options.errorsContainer).hide();
      return;
    }
    $('.form-control-feedback', el.options.classHandler(el)).tooltip('destroy').remove();
  },

  //convert class validation to parsley validation
  //should be attached to: parsley:form:init
  convertClass: function(pForm) {
    var el = pForm.$element;
    $.each(bq.global.parsley.defaults.classMap, function(key, data){
      var find = '.'+key;
      if(data.regex) { find = '[class*="'+key+'"]'; }
      el.find(find).filter(":input").each(function(){
        bq.global.parsley._createValidation($(this), data);
      });
    });

  },

  _createValidation: function(el, data) {
    // set validation prefix
    if( !$(el).is(":radio") && !$(el).is(":checkbox") ) {
      $(el).parent().addClass( bq.global.parsley.defaults.fieldValidationPrefix + $(el).prop("tagName").toLowerCase() );
    } else {
      $(el).parent().addClass( bq.global.parsley.defaults.fieldValidationPrefix + $(el).attr('type') );
    }

    var value = $.extend(true, {}, data);
    if(value.regex) {
      var classes = el.attr('class');
      var tmp = classes.match(value.regex);
      if(tmp && tmp[1]) {
        $.each(tmp, function(i, v) {
          value.value = value.value.replace('$' + i, tmp[i]);
        });
      }
    }

    if(value.extra) {
      this._createValidation(el, value.extra);
    }

    if(value.value && value.value !== '') {
      el.attr(bq.global.parsley.defaults.namespace + value.validation, value.value);
    }
  },

  //sets everything up and binds in to parsley
  setup: function(options) {
    $('[data-bq="validate-form"]').each(function() {
      if (typeof $(this).parsley(bq.global.parsley.defaults).subscribe == 'function') {
        if (options) {
          for (var option in options) {
            bq.global.parsley.defaults[option] = options[option];
          }
        }

        $(this).parsley(bq.global.parsley.defaults)
          .subscribe('parsley:form:validate', bq.global.parsley.formValidate)
          .subscribe('parsley:form:validated', bq.global.parsley.formValidated)
          .subscribe('parsley:field:error', bq.global.parsley.fieldError)
          .subscribe('parsley:field:success', bq.global.parsley.fieldSuccess);
      }

      /* -- disable 'confirm password' field when nothing is in the 'password' field -- */
      if($(this).hasClass('edit-password')){
        var password = $(this).find('input#password'),
            pConfirm = $(this).find('input#confirmation'),
            pDisable = true;

        pConfirm.prop('disabled', pDisable);

        password.on('change', function(){
          if(password.val() == ''){
            pDisable = true;
            pConfirm.val('');
          } else {
            pDisable = false;
          }

          pConfirm.prop('disabled', pDisable);
        })
      }

    });
  },

  // sets element inputs up and binds them to parsley
  setupElement: function(el) {
      $('input, select, textarea', el).each(function() {
          if (typeof $(this).parsley(bq.global.parsley.defaults).subscribe == 'function') {
              $(this).parsley(bq.global.parsley.defaults)
                  .subscribe('parsley:form:validate', bq.global.parsley.formValidate)
                  .subscribe('parsley:field:error', bq.global.parsley.fieldError)
                  .subscribe('parsley:field:success', bq.global.parsley.fieldSuccess);
          }
      });
  },

  setupSingle: function(el) {
    if (typeof $(el).parsley(bq.global.parsley.defaults).subscribe == 'function') {
        $(el).parsley(bq.global.parsley.defaults)
            .subscribe('parsley:form:validate', bq.global.parsley.formValidate)
            .subscribe('parsley:field:error', bq.global.parsley.fieldError)
            .subscribe('parsley:field:success', bq.global.parsley.fieldSuccess);
    }
  },

  destroySingle: function(el) {
    if (this.validationEnabled($(el))) {
      $(el).parsley().destroy();
    }
  },

  //removes parsley bindings
  destroy: function() {
    var $this = this;
    $('[data-bq="validate-form"]').each(function(i, formEl) {
      ($this.validationEnabled($(formEl))) && $(formEl).parsley().destroy();
    });
  },

  validate: function(el) {
    if (this.validationEnabled($(el))) {
      return $(el).parsley().validate();
    }
  },

  validationEnabled: function(el) {
    return $(el).data('Parsley') !== undefined;
  },

  validationEnabledForElement: function(el) {
    var $this = this;
    var result = false;

    $('input, select', el).each(function() {
      if ($this.validationEnabled($(this))) {
        result = true;
      }
    });

    return result;
  },

  destroyElement: function(el) {
    var $this = this;
    $('input, select', el).each(function() {
      if ($this.validationEnabled($(this))) {
        $(this).parsley().destroy();
      }
    });
  },

  validateElement: function(el) {
    var $this = this;

    $('input, select, textarea', el).each(function() {
      if ($this.validationEnabled($(this))) {
        return $(this).parsley().validate();
      }
    });
  },

  isValid: function(el) {
    if (this.validationEnabled($(el))) {
      return $(el).parsley().isValid()
    }
  },

  fieldAddForcedError: function(el, errorMessage) {
    if (el.length <= 0) return;

    window.ParsleyUI.addError($(el).parsley(), $(el).attr('name') + 'forced-error', errorMessage);

    if (errorMessage === ' ') return;

    var icon = $('<span class="fa fa-exclamation-triangle text-error form-control-feedback form-validation-error"></span>');
    var parent = el.parent();

    parent.prepend(icon);

    icon.tooltip({
      container: 'body',
      html: true,
      placement: 'left auto',
      title: errorMessage
    });
  },

  fieldRemoveForcedError: function(el) {
      if (!el.length || !el.closest('.has-feedback').length) return;

      window.ParsleyUI.removeError($(el).parsley(), $(el).attr('name') + 'forced-error');
      $('.form-control-feedback', $(el).parent()).tooltip('destroy').remove();
  }
};

window.ParsleyValidator
  .addValidator('dateafterexpiraton', function (value, requirement) {
    var convertToISO = function (input) {
        var parts = input.split('/');
        if (parts.length === 3) {
            input = window.ParsleyValidator.locale === 'en'
                ? parts[2] + '/' + parts[0] + '/' + parts[1]
                : parts.reverse().join('-');
        }
        return input;
    };
    // Convert date strings to ISO format
    var effectiveFrom = convertToISO($('input[name="effective_from"]').val());
    var expireFrom = convertToISO(value);

    var expirationDate = Date.parse(expireFrom);
    var effectiveDate = Date.parse(effectiveFrom);

    return expirationDate >= effectiveDate ;
  })
  .addMessage(bq.config.locale, 'dateafterexpiraton', bq.messages.global.date_cannot_be_earlier_then_the_effective_date);

window.ParsleyValidator
  .addValidator('receiptreturnedqty', function (value, requirement) {
    var row = jQuery('tr[rel="' + requirement + '"]', '#edit-receipt-form');
    var prevReceived = accounting.unformat(jQuery('td[data-bq-il-type="qty_received"]', row).text());
    var received = accounting.unformat(jQuery('input.qty-to-receive[name="receipt[items][' + requirement + ']"]').val());
    value = accounting.unformat(value);

    return value <= prevReceived + received;
  })
  .addMessage(bq.config.locale, 'receiptreturnedqty', bq.messages.global.qty_returned_cant_greater_sum);

window.ParsleyValidator
  .addValidator('receiptreturnedamount', function (value, requirement) {
    var row = jQuery('tr[rel="' + requirement + '"]', '#edit-receipt-form');
    var received = accounting.unformat(jQuery('input.amount-to-receive[name="receipt[items][' + requirement + ']"]').val());
    var prevReceived = accounting.unformat(jQuery('td[data-bq-il-type="amount_received"]', row).text());
    value = accounting.unformat(value);

    return value <= prevReceived + received;
  })
  .addMessage(bq.config.locale, 'receiptreturnedamount', bq.messages.global.amount_returned_cant_greater_sum);

window.ParsleyValidator
  .addValidator('qtyincrement', function (value, requirement) {
    var reqArray = requirement.split(',');
    var min = Math.max(reqArray[0], reqArray[2]);
    var max = parseFloat(reqArray[1]);
    var req = parseFloat(reqArray[2]);

    if (bq.helper.getExactDivision(value, req) !== 0 || value < min || value > max) {
      var message;
      if (isNaN(max)) {
          message = sprintf(bq.messages.global.order_in_increment_of_min, req, min);
      } else {
          message = sprintf(bq.messages.global.order_in_increment_of, req, min, max);
      }
      window.ParsleyValidator.addMessage(bq.config.locale, 'qtyincrement', message);
      return false;
    } else {
      return true;
    }
  });

window.ParsleyValidator
    .addValidator('valuegreaterthan', function (value, requirement) {
      var min = parseInt(requirement);

      if (value <= min || isNaN(min)) {
        var message;
        message = sprintf(bq.messages.global.valuegreaterthan, min);
        window.ParsleyValidator.addMessage(bq.config.locale, 'valuegreaterthan', message);
        return false;
      } else {
        return true;
      }
    });

window.ParsleyValidator
    .addValidator('valuelessthan', function (value, requirement) {
      var max = parseInt(requirement);

      if (value >= max || isNaN(max)) {
        var message;
        message = sprintf(bq.messages.global.valuelessthan, max);
        window.ParsleyValidator.addMessage(bq.config.locale, 'valuelessthan', message);
        return false;
      } else {
        return true;
      }
    });

window.ParsleyValidator
    .addValidator('minreceived', function (value, requirement) {
        return accounting.unformat(value) >= accounting.unformat(requirement);
    })
    .addMessage(bq.config.locale, 'minreceived', bq.messages.global.minreceived);

window.ParsleyValidator
  .addValidator('attachmenterrors', function (value) {
    var errors = $('.attachment-list-item.attachment-list-item-error');
    if (errors.length > 1) return false;
    return true;
  })
  .addMessage(bq.config.locale, 'attachmenterrors', bq.messages.global.fileSize);

window.ParsleyValidator
  .addValidator('attachmentloadinginprogress', function (value) {
    var isLoadingInProgress = $('.attachment-list-item.attachment-list-item-upload');
    if (isLoadingInProgress.length > 1) return false;
    return true;
  })
  .addMessage(bq.config.locale, 'attachmentloadinginprogress', bq.messages.global.processingRequest);

window.ParsleyValidator
  .addValidator('attachmentrequired', function (value) {
    var files = $('.attachment-list');
    if (!files || files.find('[data-ajax-params]').length === 0) return false;
    return true;
  })
  .addMessage(bq.config.locale, 'attachmentrequired', bq.messages.global.parsley.required);

window.ParsleyValidator
    .addValidator('beforedate', function (value, requirement) {
        return moment(value, bq.config.dateFormat) > moment($(requirement).val() , bq.config.dateFormat);
    })
    .addMessage(bq.config.locale, 'beforedate', bq.messages.global.date_cannot_be_earlier_then_the_start_date);

window.ParsleyValidator
    .addValidator('maxdelegation', function (value, requirement) {
        var maxDays = parseInt(requirement[1]),
        startDate = moment($(requirement[0]).val() , bq.config.dateFormat),
        endDate   = moment(value , bq.config.dateFormat);
        if (maxDays > 0) {
            return (endDate.diff(startDate, 'days') <= maxDays);
        }
        return true;
    })
    .addMessage(bq.config.locale, 'maxdelegation', bq.messages.global.date_cannot_be_maximum_delegation_days);

window.ParsleyValidator
    .addValidator('dateinrange', function (value, requirement) {
        let date1 = new Date(requirement[0]),
            date2 = new Date(requirement[1]);
        if (date1 === date2 || "Invalid Date" === date1.toString() || "Invalid Date" === date2.toString()) {
            console.error('Attempt to validate date in incorrect range: [%s]'.replace(new RegExp('%s', 'i'), requirement.join('; ')));
            return true;
        }

        if (date1 > date2) {    // swap if necessary
            date2 = [date1, date1 = date2][0];
        }

        const date0 = new Date(value);

        if (date1 > date0 || date0 > date2) {
            window.ParsleyValidator.addMessage(bq.config.locale, 'dateinrange', 'Please enter a valid date between %s and %s');
            return false;
        }

        return true;
    });

//parsley event binding
$.listen('parsley:form:init', bq.global.parsley.convertClass);

//global event bindings

bq.init.push(bq.global.parsley.setup);
